module.exports = __webpack_public_path__ + "img/wbanner_50.66bdc72a.png";